'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UIPopoverFooter',

  propTypes: {
    align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    flush: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left'
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        flush = _props.flush;

    return (0, _reactUtils.classNames)('uiPopoverFooter', 'private-popover__footer', className, {
      'private-popover__footer--flush': flush
    }, {
      'text-right': align === 'right'
    });
  },
  render: function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'footer',
      { className: this.getClassName() },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/tooltip/UIPopoverFooter.js
// module id = 257
// module chunks = 0